import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";

const LAYERS = [
    {
        n: "01",
        title: "Investigação Comercial",
        desc: "Mapeamento exato de onde a jornada do cliente está vazando receita e oportunidades.",
    },
    {
        n: "02",
        title: "Inteligência Econômica",
        desc: "Análise fria de custos, alocação de recursos e unidade econômica do seu negócio.",
    },
    {
        n: "03",
        title: "Inteligência de Recuperação",
        desc: "Identificação do que precisa ser corrigido urgentemente antes de você gastar mais com aquisição.",
    },
    {
        n: "04",
        title: "Reconstrução",
        desc: "Quando as evidências apontam que a identidade, os processos ou a gestão precisam ser reestruturados.",
    },
];

export default function Methodology() {
    const trackRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: trackRef,
        offset: ["start 0.75", "end 0.6"],
    });
    const scaleY = useSpring(scrollYProgress, { stiffness: 90, damping: 28 });

    return (
        <section
            id="metodologia"
            className="relative border-t border-gold-faint bg-[#0a0a0a] px-6 py-28 lg:px-10 lg:py-36"
            data-testid="methodology-section"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <div className="lg:sticky lg:top-32">
                        <Reveal>
                            <Eyebrow>Exhibit B — A Solução</Eyebrow>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <h2 className="mt-7 font-serif text-3xl leading-tight text-white sm:text-4xl lg:text-5xl">
                                A Metodologia das{" "}
                                <em className="italic text-gold">4 Camadas</em>
                            </h2>
                        </Reveal>
                        <Reveal delay={0.16}>
                            <p className="mt-7 max-w-sm text-lg font-light leading-relaxed text-[#e6e6e6]">
                                Não partimos da solução. Investigamos onde o problema realmente
                                está.
                            </p>
                        </Reveal>
                        <Reveal delay={0.22}>
                            <div className="mt-10 hidden max-w-sm border-l-2 border-gold pl-6 lg:block">
                                <p className="font-mono text-[10px] uppercase leading-relaxed tracking-[0.25em] text-[#666666]">
                                    Cada camada só se inicia quando a anterior apresenta
                                    evidências conclusivas.
                                </p>
                            </div>
                        </Reveal>
                    </div>
                </div>

                <div className="lg:col-span-7" data-testid="methodology-timeline">
                    <div ref={trackRef} className="relative pl-10">
                        <div className="absolute bottom-4 left-[7px] top-2 w-px bg-line">
                            <motion.div
                                style={{ scaleY }}
                                className="absolute inset-0 origin-top bg-gold"
                                data-testid="methodology-progress-line"
                            />
                        </div>
                        {LAYERS.map((l, i) => (
                            <Reveal
                                key={l.n}
                                delay={i * 0.04}
                                className="relative mb-20 last:mb-0"
                            >
                                <span className="absolute -left-[33px] top-3 h-2 w-2 rotate-45 border border-gold bg-[#0a0a0a]" />
                                <p
                                    className="font-display text-5xl leading-none text-stroke-gold lg:text-6xl"
                                    data-testid={`methodology-layer-${i + 1}`}
                                >
                                    {l.n}
                                </p>
                                <h3 className="mt-5 font-serif text-2xl text-white">{l.title}</h3>
                                <p className="mt-3 max-w-lg text-[15px] leading-relaxed text-[#9a9a9a]">
                                    {l.desc}
                                </p>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
